import config from 'config';
import React from 'react';
import styled from 'styled-components';

import Arrow from 'components/Icons/Arrow';
import StoreButton from 'components/StoreButton';
import getDeviceInfo, { DeviceType, OS } from 'helpers/getDeviceInfo';
import theme from 'theme/theme';

import SectionTitle from './sections/SectionTitle';

type Props = {
  goToNextSection: () => void;
  isMobile?: boolean;
};

const GetAppSection = ({ isMobile, goToNextSection }: Props) => {
  const isTablet = getDeviceInfo().platform === DeviceType.Tablet;
  const isIOSDevice = getDeviceInfo().name === OS.Ios;

  const isIphone = isMobile && isIOSDevice;
  const isAndroid = isMobile && !isIOSDevice;
  const isNotIpad = isTablet && !isIOSDevice;
  const isDesktop = !isMobile && !isTablet;

  return (
    <Container>
      <SectionTitle>
        Shido mobile app available on App Store and Google Play
      </SectionTitle>
      <StoreButtonsWrapper>
        {isIphone && (
          <StoreButton
            color={theme.colors.black}
            variant="appStore"
            href={config.appStoreLink}
            isMobile={isMobile}
          />
        )}
        {isAndroid && (
          <StoreButton
            color={theme.colors.black}
            variant="googlePlay"
            href={config.googlePlayLink}
            isMobile={isMobile}
          />
        )}
        {isTablet && (
          <StoreButton
            color={theme.colors.black}
            variant="appStore"
            href={config.appStoreLink}
          />
        )}
        {isNotIpad && (
          <StoreButton
            color={theme.colors.black}
            variant="googlePlay"
            href={config.googlePlayLink}
          />
        )}
        {isDesktop && (
          <>
            <StoreButton
              color={theme.colors.darkBlueV2}
              variant="appStore"
              href={config.appStoreLink}
            />
            <StoreButton
              color={theme.colors.darkBlueV2}
              variant="googlePlay"
              href={config.googlePlayLink}
            />
          </>
        )}
      </StoreButtonsWrapper>
      <ArrowWrapper onClick={goToNextSection}>
        <Arrow />
      </ArrowWrapper>
    </Container>
  );
};

const Container = styled.section`
  max-width: 1400px;
  padding: 78px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px dashed rgba(65 78 113 / 25%);

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`;

const StoreButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin: 20px 0 40px;
`;

const ArrowWrapper = styled.div`
  text-align: center;
  cursor: pointer;
  margin: 0 auto;
`;

export default GetAppSection;
